module.exports = __webpack_public_path__ + "fonts/Brygada_1918-400-latin6.c604572.woff2";